import React, { FunctionComponent, memo } from 'react'

import { useTranslation } from 'react-i18next'
import { LayoutProps, LineHeightProps, SpaceProps } from 'styled-system'

import { ErrorText } from '@/atoms/typography'

export type TransError = { transKey: string; values: Record<string, string | number> }
export type ErrorValue = string | TransError
export type ErrorInput = ErrorValue | ErrorValue[]

interface OwnProps {
  error: ErrorInput
}

type Props = OwnProps & (SpaceProps | LayoutProps | LineHeightProps)

const renderError = (t: any, e: ErrorValue) => (typeof e === 'string' ? t(e) : t(e.transKey, e.values))

const ErrorMessage: FunctionComponent<Props> = ({ error, ...fieldProps }: Props) => {
  const { t } = useTranslation()

  if (Array.isArray(error)) {
    const filtered = error.filter(Boolean)
    if (!filtered.length) return null

    return (
      <>
        {filtered.map((e, idx) => (
          <ErrorText key={idx} {...fieldProps}>
            {renderError(t, e)}
          </ErrorText>
        ))}
      </>
    )
  }

  return <ErrorText {...fieldProps}>{renderError(t, error)}</ErrorText>
}

ErrorMessage.displayName = 'ErrorMessage'

export default memo(ErrorMessage)
